/* wildpretii · borrador minimalista · script base */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Aparición al hacer scroll ---------- */
  const aparecen = $$('.aparece');
  if ('IntersectionObserver' in window && aparecen.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    aparecen.forEach((el) => io.observe(el));
  } else { aparecen.forEach((el) => el.classList.add('visible')); }

  /* ---------- Cabecera: desplegables accesibles y sombra al hacer scroll ---------- */
  $$('.cabecera__menu > li > button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const li = btn.parentElement; const abierto = li.classList.toggle('abierto');
      btn.setAttribute('aria-expanded', abierto);
      $$('.cabecera__menu > li.abierto').forEach((o) => { if (o !== li) { o.classList.remove('abierto'); o.querySelector('button')?.setAttribute('aria-expanded', 'false'); } });
    });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('.cabecera__menu')) $$('.cabecera__menu > li.abierto').forEach((o) => o.classList.remove('abierto')); });
  const cab = $('.cabecera');
  const envoltura = $('.cabecera-envoltura');
  if (cab) {
    const sobreHero = !!$('.hero') && envoltura && envoltura.dataset.sobreHero === 'true';
    const alScroll = () => { cab.classList.toggle('cabecera--desplazada', window.scrollY > 24); };
    alScroll(); window.addEventListener('scroll', alScroll, { passive: true });
    if (sobreHero) envoltura.classList.add('cabecera-envoltura--sobre-hero');
    const medirCabecera = () => { if (envoltura) document.documentElement.style.setProperty('--alto-cabecera', envoltura.offsetHeight + 'px'); };
    medirCabecera(); window.addEventListener('resize', medirCabecera);
  }

  /* ---------- Títulos ajustados a una sola línea (ancho del contenedor) ---------- */
  const ajustarLineas = () => {
    $$('[data-ajustar-linea]').forEach((h) => {
      const ancho = h.parentElement.clientWidth; if (!ancho) return;
      if (window.innerWidth < 861) { h.style.fontSize = ''; return; }
      h.style.fontSize = '100px';
      const medido = h.scrollWidth; if (!medido) return;
      h.style.fontSize = Math.max(28, Math.min(104, 100 * ancho / medido)) + 'px';
    });
  };
  ajustarLineas(); window.addEventListener('resize', ajustarLineas);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustarLineas);

  /* ---------- Menú móvil ---------- */
  const menuMovil = $('.menu-movil');
  const abrirMenu = () => { menuMovil.classList.add('abierto'); document.body.style.overflow = 'hidden'; };
  const cerrarMenu = () => { menuMovil.classList.remove('abierto'); document.body.style.overflow = ''; };
  $$('[data-abrir-menu]').forEach((b) => b.addEventListener('click', abrirMenu));
  $$('[data-cerrar-menu]').forEach((b) => b.addEventListener('click', cerrarMenu));
  $$('.menu-movil__lista > li > button').forEach((b) => b.addEventListener('click', () => b.parentElement.classList.toggle('abierto')));

  /* ---------- Carrito lateral ---------- */
  const cartDrawer = $('#carrito-lateral');
  const abrirCarrito = () => { document.body.classList.add('carrito-abierto'); document.body.style.overflow = 'hidden'; cartDrawer?.setAttribute('aria-hidden', 'false'); };
  const cerrarCarrito = () => { document.body.classList.remove('carrito-abierto'); document.body.style.overflow = ''; cartDrawer?.setAttribute('aria-hidden', 'true'); };
  $$('[data-abrir-carrito]').forEach((b) => b.addEventListener('click', (e) => { if (cartDrawer && cartDrawer.dataset.activo === 'true') { e.preventDefault(); abrirCarrito(); } }));
  $$('[data-cerrar-carrito]').forEach((b) => b.addEventListener('click', cerrarCarrito));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { cerrarCarrito(); cerrarMenu(); } });

  async function refrescarCarrito(abrir) {
    if (!cartDrawer) return;
    const res = await fetch(`${window.Shopify?.routes?.root || '/'}?section_id=carrito-lateral`);
    const html = await res.text();
    const nuevo = new DOMParser().parseFromString(html, 'text/html').querySelector('#carrito-lateral');
    if (nuevo) { cartDrawer.innerHTML = nuevo.innerHTML; enlazarCarrito(); }
    const contador = $$('[data-contador-carrito]');
    const cuenta = nuevo?.dataset.cantidad || '0';
    contador.forEach((c) => { c.textContent = cuenta; c.hidden = cuenta === '0'; });
    if (abrir) abrirCarrito();
  }

  async function cambiarLinea(key, quantity) {
    await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    refrescarCarrito(false);
  }

  function enlazarCarrito() {
    $$('[data-cerrar-carrito]', cartDrawer).forEach((b) => b.addEventListener('click', cerrarCarrito));
    $$('[data-linea]', cartDrawer).forEach((linea) => {
      const key = linea.dataset.linea; const input = $('input', linea);
      $('[data-mas]', linea)?.addEventListener('click', () => cambiarLinea(key, Number(input.value) + 1));
      $('[data-menos]', linea)?.addEventListener('click', () => cambiarLinea(key, Math.max(0, Number(input.value) - 1)));
      $('[data-quitar]', linea)?.addEventListener('click', (e) => { e.preventDefault(); cambiarLinea(key, 0); });
      input?.addEventListener('change', () => cambiarLinea(key, Number(input.value)));
    });
    enlazarFormulariosProducto(cartDrawer);
  }

  /* ---------- Añadir al carrito por AJAX ---------- */
  function enlazarFormulariosProducto(raiz = document) {
    $$('form[data-formulario-producto]', raiz).forEach((form) => {
      if (form.dataset.enlazado) return; form.dataset.enlazado = '1';
      form.addEventListener('submit', async (e) => {
        if (!cartDrawer || cartDrawer.dataset.activo !== 'true') return;
        e.preventDefault();
        const btn = $('[type=submit]', form); const texto = btn?.textContent;
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Añadiendo…'; }
        try {
          const fd = new FormData(form);
          const r = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
          if (!r.ok) throw new Error('No se pudo añadir');
          await refrescarCarrito(true);
        } catch (err) { alert('No se pudo añadir el producto. Inténtalo de nuevo.'); }
        finally { if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = texto; } }
      });
    });
  }
  enlazarFormulariosProducto();
  if (cartDrawer) enlazarCarrito();

  /* ---------- Cantidad en ficha ---------- */
  $$('.cantidad').forEach((c) => {
    const input = $('input', c);
    $('[data-mas]', c)?.addEventListener('click', () => { if (!c.closest('[data-linea]')) input.value = Number(input.value) + 1; });
    $('[data-menos]', c)?.addEventListener('click', () => { if (!c.closest('[data-linea]')) input.value = Math.max(1, Number(input.value) - 1); });
  });

  /* ---------- Selector de variantes ---------- */
  const formCompra = $('#formulario-compra');
  if (formCompra && $('[data-variantes]', formCompra)) {
    const variantes = JSON.parse($('[data-variantes]', formCompra).textContent);
    $$('[data-selector-variante]', formCompra).forEach((sel) => sel.addEventListener('change', () => {
      const titulo = $$('[data-selector-variante]', formCompra).map((x) => x.value).join(' / ');
      const v = variantes.find((x) => x.title === titulo);
      if (v) { $('#variante', formCompra).value = v.id; const btn = $('[type=submit]', formCompra); btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.texto || 'Añadir al carrito' : 'Agotado'; }
    }));
  }

  /* ---------- Galería de producto ---------- */
  $$('.galeria').forEach((g) => {
    const principal = $('.galeria__principal img', g);
    $$('.galeria__miniaturas button', g).forEach((b) => b.addEventListener('click', () => {
      principal.src = b.dataset.src; principal.srcset = b.dataset.srcset || ''; principal.alt = b.dataset.alt || '';
      $$('.galeria__miniaturas button', g).forEach((x) => x.classList.remove('activa')); b.classList.add('activa');
    }));
  });

  /* ---------- Barra de compra fija en móvil ---------- */
  const barraMovil = $('.barra-compra-movil'); const botonCompra = $('.ficha__compra [type=submit]');
  if (barraMovil && botonCompra && 'IntersectionObserver' in window) {
    new IntersectionObserver((en) => { barraMovil.classList.toggle('visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(botonCompra);
    $('[data-ir-compra]', barraMovil)?.addEventListener('click', () => botonCompra.closest('form')?.requestSubmit());
  }

  /* ---------- Vídeo de historia (clic para reproducir con sonido) ---------- */
  $$('[data-reproducir-video]').forEach((b) => b.addEventListener('click', () => {
    const cont = b.closest('.historia__medio'); const v = $('.historia__video', cont); const img = $('img', cont);
    if (!v) return; img && (img.style.display = 'none'); b.style.display = 'none'; v.style.display = 'block'; v.play();
  }));

  /* ---------- Pestañas de activos en la ficha ---------- */
  $$('.activo-pestana').forEach((b) => b.addEventListener('click', () => {
    const n = b.dataset.activo;
    $$('.activo-pestana').forEach((x) => { x.classList.toggle('activo-pestana--activa', x === b); x.setAttribute('aria-selected', x === b); });
    $$('.activo-panel').forEach((p) => { const on = p.dataset.activo === n; p.hidden = !on; p.classList.toggle('activo-panel--activo', on); });
  }));

  /* ---------- Marquesina: duplicar contenido para bucle continuo ---------- */
  $$('.marquesina__pista').forEach((p) => { p.innerHTML += p.innerHTML; });
})();
